import { PropsWithChildren } from 'react';

export const GraphTitle = ({ children }: PropsWithChildren<unknown>) => (
  <text x={8} y={16} dominantBaseline="middle" style={{ fontSize: 16, fontWeight: 700 }}>
    {children}
  </text>
);
